import { ReactElement } from 'react';
import { StyledIcon } from './AttachIcon-style';
import { IAttachIconProps } from './AttachIcon-type';

export const AttachIcon = (props: IAttachIconProps): ReactElement => {
  const { type = 'link', ...restProps } = props;

  return <StyledIcon type={type} {...restProps} />;
};
